import { render, staticRenderFns } from "./result-summary.vue?vue&type=template&id=c6450a78&"
import script from "./result-summary.vue?vue&type=script&lang=js&"
export * from "./result-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports